import baseRoute from '../baseRoute';

type RouteDefinition = `${typeof baseRoute}/${number | ':fieldReportId'}/resetJobWorkSummary`;

export const ROUTE: RouteDefinition = `${baseRoute}/:fieldReportId/resetJobWorkSummary`;

export const URL = (fieldReportId: number): RouteDefinition =>
	`${baseRoute}/${fieldReportId}/resetJobWorkSummary`;
